import {useContext, useState, useEffect} from "react";
import AuthContext from "context/AuthContext";
import axios from "axios";
import {useTranslation} from "react-i18next";

const LoginOTPSetupEmail = () => {
    const {completeSetupLogin} = useContext(AuthContext);
    const {t: _Ta} = useTranslation("authenticate");
    const [token, setToken] = useState("");
    const [sent, setSent] = useState(false);
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const sendCode = () => {
        axios
            .get("/api/two-factor/setup/?type=email")
            .then(() => setSent(true))
            .catch(() => setError(true));
    };

    useEffect(() => {
        sendCode();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(false);
        try {
            const {data, status} = await axios.post("/api/two-factor/confirm/", {code: token, type: "email"});
            if (status === 200 && data.status) {
                if (data.device_token) {
                    localStorage.setItem("device_token", data.device_token);
                }
                completeSetupLogin();
            } else {
                setError(true);
            }
        } catch {
            setError(true);
        }
        setLoading(false);
    };

    return (
        <div className="form-signin w-100 m-auto">
            <form onSubmit={handleSubmit}>
                <h1 className="h5 mb-3 fw-normal text-center">{_Ta("title.otp-setup-email")}</h1>
                <p className="mb-3 text-center">{_Ta("title.otp-setup-email-desc")}</p>
                {sent && (
                    <p className="text-success text-center mb-3">{_Ta("messages.email-sent")}</p>
                )}
                {error && (
                    <p className="error-message text-center bg-danger text-light mb-2">
                        {_Ta("messages.error-otp")}
                    </p>
                )}
                <div className="form-floating mb-3">
                    <input
                        type="text"
                        id="otp"
                        className="form-control"
                        placeholder="000000"
                        maxLength={6}
                        value={token}
                        onChange={(e) => setToken(e.target.value)}
                        autoFocus
                    />
                    <label htmlFor="otp">{_Ta("labels.otp")}</label>
                </div>
                <button className="btn btn-primary w-100 mb-2" type="submit" disabled={loading}>
                    {_Ta("buttons.verify-otp")}
                </button>
                <button type="button" className="btn btn-outline-secondary w-100" onClick={sendCode} disabled={loading}>
                    {_Ta("buttons.resend-code")}
                </button>
            </form>
        </div>
    );
};
export default LoginOTPSetupEmail;
